// file imports
import { LoadingSpinner } from '@/components';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullScreen?: boolean;
}

export default function LoadingState({ message = 'Loading...', size = 'md', className = '', fullScreen = false }: LoadingStateProps) {
  const containerClasses = fullScreen ? 'min-h-screen flex items-center justify-center' : 'min-h-[50vh] flex items-center justify-center';

  return (
    <div className={`${containerClasses} ${className}`}>
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner size={size} />
        <p className="text-gray-600 text-lg font-medium">{message}</p>
      </div>
    </div>
  );
}
